
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMApp } from "@/store";
import ComplianceProfile from "@/modules/Compliance/Profile/ComplianceProfile.vue";
import { RCandidatesBrowse } from "@/modules/Services/Template/views/Candidates/Browse/RCandidatesBrowse";
import VTemplateProfile from "@/modules/Services/Template/views/Profile/VTemplateProfile.vue";

const SPONSORSHIP_CANDIDATE_PROFILE = "SponsorshipCandidateProfile";

const ICONS = {
  back: "arrow-back-outline",
};

@Component({
  components: {
    VTemplateProfile,
    ComplianceProfile,
  },
})
export default class EmployeeProfilePersonalInfo extends Vue {
  ICONS = ICONS;

  type = SPONSORSHIP_CANDIDATE_PROFILE;

  goToSponsorshipCandidates() {
    this.$router.push({
      name: RCandidatesBrowse.name,
    });
  }

  get caseId() {
    return Number(this.$route.params.id ?? 0);
  }

  get candidateId() {
    return Number(this.$route.params.sponsorship_candidate_id ?? 0);
  }

  mounted() {
    this.fetchName();
  }

  candidate = null;

  setPageSectionName(item) {
    const name = this.getCandidateName(item);

    if (!name) return;

    const sectionName = `${name}`;

    SMApp.setPageSubTitle(sectionName);
  }

  async fetchName() {
    const { caseId, candidateId } = this;

    const { data } = await this.axios.get(
      API_ROUTES.COMPANY_SPONSORSHIP_CANDIDATE_INFO(caseId, candidateId)
    );

    this.setPageSectionName(data);
  }

  getCandidateName(candidate) {
    const { first_name, last_name } = candidate;

    let name = "";

    name += first_name ? `${first_name} ` : "";
    name += last_name ? last_name : "";

    return name;
  }
}
